// @flow
import Vue from 'vue'
import moment from 'moment'

const DATE_FORMAT_DISPLAY_MOMENTJS = 'DD-MM-YYYY'
const DATE_TIME_FORMAT_DISPLAY_MOMENTJS = 'DD-MM-YYYY HH:mm'

const dateFormat = function (value: Date) {
  return moment(value).format(DATE_FORMAT_DISPLAY_MOMENTJS)
}
const dateTimeFormat = function (value: Date) {
  return moment(value).format(DATE_TIME_FORMAT_DISPLAY_MOMENTJS)
}

const dateFormatOrDefault = function (value: ?Date, defaultValue: String) {
  return value !== null && value !== undefined ? dateFormat(value) : defaultValue
}

const dateTimeFormatOrDefault = function (value: ?Date, defaultValue: String) {
  return value !== null && value !== undefined ? dateTimeFormat(value) : defaultValue
}
Vue.filter('dateFormat', dateFormat)

export default dateFormat
export { dateFormatOrDefault, dateTimeFormatOrDefault }



// WEBPACK FOOTER //
// ./src/filters/date-format.js